<template>
  <div class="cf-node-properties__routing-filter">
    <FilterCriteria
      v-model="parsedCriteria"
      :available-tags="availableTags"
      @change="handleCriteriaChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import messages from '../../../../locales';
import FilterCriteria from '@/core/components/FilterCriteria/FilterCriteria';
import { cloneDeep } from 'lodash';
import { convertComparisonTypes, transformGeoTag, transformGeoTagBackendObj } from '../../../../helpers/tags';

export default {
  name: 'RouteFilter',
  components: {
    FilterCriteria
  },
  props: {
    filterCriteria: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      parsedCriteria: []
    };
  },
  computed: {
    ...mapState('callFlows', ['availableTags']),
  },
  watch: {
    'filterCriteria': {
      handler() {
        this.parsedCriteria = this.parseCriteria(this.filterCriteria);
      },
      immediate: true,
      deep: true
    },
  },
  created() {
    this.parsedCriteria = this.parseCriteria(this.filterCriteria);
  },
  methods: {
    handleCriteriaChange() {
      const criteriaClone = this.parseCriteria(this.parsedCriteria);
      this.$emit('update:filterCriteria', transformGeoTagBackendObj(criteriaClone));
    },
    parseCriteria(criteria) {
      let criteriaClone = cloneDeep(criteria);
      criteriaClone = convertComparisonTypes(criteriaClone);
      criteriaClone = transformGeoTag(criteriaClone);
      return criteriaClone;
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>